import { Component, HostListener, OnInit } from '@angular/core';
import { AnalyzeService } from 'src/app/appServices/AnalyzeService/analyzeService.service';
import { DatePipe } from '@angular/common';
import { Chart } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { drawDOM, exportPDF, Group, } from "@progress/kendo-drawing";
import { saveAs } from "@progress/kendo-file-saver";
import { LocalStorage } from 'src/app/appCommon/Enums/enum';
import { HelperService } from 'src/app/appServices/HelperService/helper.service';
import { AxisLabelContentArgs, LineStyle, SeriesLabels, SeriesLabelsContentArgs, ValueAxisLabels } from "@progress/kendo-angular-charts";
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-facility-dashboard',
  templateUrl: './facility-dashboard.component.html',
  styleUrls: ['./facility-dashboard.component.scss'],
})
export class FacilityDashboardComponent implements OnInit {
  public style: LineStyle = "smooth";
  public lineChartPlugins = [ChartDataLabels];
  doortostartmeancal: any = [];
  doortostartmediancal: any = [];
  FilterDashboardFacultyPiList: any = [];
  totalRecords = 0;
  pageNumber = 1;
  rows = 10;
  sortOrder = 'Asc';
  sortCol = '';
  filterVal = '';
  cols: any;
  chartBool: boolean = false;
  multiAxisData: any;
  multiAxisBarChartData: any;
  chartsTitle: any;
  chartsMean: any;
  chartsMeanCalculation: any;
  chartsCategory: any;
  chartsMinDate: any;
  flag = 0;
  datePipe = new DatePipe('en-US');
  exportPdfLoader: boolean = false;
  loader = [false, false, false, false, false];
  loading: any = [];
  loaders = { value: false }
  chartDatasets: any = [];
  barChartDatasets: any = [];
  barChartCategories: any = [];
  filter_option: string = 'facility';
  showProgressSpinner: boolean = false;
  facilityDasboardReplica: any = [];
  UId: any;
  RoleName: any;
  seriesColors: string[] = [];
  name: any;
  screenWidth: number = 0;
  chartFoundBool: boolean = false;
  private subscription: Subscription[] = [];


  public seriesLabels: SeriesLabels = {
    visible: true, // Note that visible defaults to false
    padding: 3,
    font: "bold 14px Arial, sans-serif",
    color: "#000000"
  };
  public valueAxisLabels: ValueAxisLabels = {
    font: "bold 14px Arial, sans-serif",
    color: "#000000"
  };
  public series: any = {
    color: '#ed2078',
    colorLabel: '#ed2078',
    font: "bold 14px Arial, sans-serif"
  };
  public seriesWidth: any = {
    font: "bold 8px Arial, sans-serif"
  };
  public titleAlignment: any = {
    align: 'start'
  };
  barBool: boolean = false;
  lineChartCategories: any = [];
  array: any = [];
  labelContent: any;
  array1: any = [];
  arrayToShowYaxis: any;
  minDate!: number;
  reportType: any;
  bodyFacilityImprovefacilityList: any = [];
  headerFacilityImprovefacilityList: any;
  fromMonth: any;
  toMonth: any;
  FilterType: any;

  constructor(public analyzeService: AnalyzeService, private helperService: HelperService) { }
  ngOnInit(): void {
    this.UId = this.helperService.decryption(localStorage.getItem(LocalStorage.UId));
    this.RoleName = this.helperService.decryption(localStorage.getItem(LocalStorage.UserRoleName));
    Chart.unregister(ChartDataLabels);
    this.analyzeService._facilityPiComponent.FacilityDashboardComponent = this;
    if (
      this.analyzeService._facilityPiRecord.FacilityDashboardRecord != null &&
      this.analyzeService._facilityPiRecord.FacilityDashboardRecord != undefined
    ) {
      this.FilterDashboardFacultyPiList =
        this.analyzeService._facilityPiRecord.FacilityDashboardRecord;
    }
    if (this.analyzeService._facilityPiFilterObj.FacilityDashboardDataObj != undefined) {
      this.analyzeService._facilityPiComponent.FacilityPIComponent.getFacilityDashboardValues();
    }
    this.screenWidth = window.innerWidth;
  }

  @HostListener('window:resize', ['$event']) onResize(event: any) {
    this.screenWidth = window.innerWidth;
  }

  getFacilityDashboardValues(onClickDisable: any, excel_chartDisabe: any, filterOption: any, loader: any) {
    this.facilityDasboardReplica = [];
    this.totalRecords = 0;
    this.showProgressSpinner = true;
    this.reportType = this.analyzeService._facilityPiFilterObj.FacilityDashboardDataObj.data.ReportType;
    this.fromMonth = this.analyzeService._facilityPiFilterObj.FacilityDashboardDataObj.data.fromMonth;
    this.toMonth = this.analyzeService._facilityPiFilterObj.FacilityDashboardDataObj.data.toMonth;
    this.FilterType = this.analyzeService._facilityPiFilterObj.FacilityDashboardDataObj.data.FilterType;
    this.subscription.push(
      this.analyzeService
        .getFacilityDashboardValues(this.RoleName, this.UId,
          this.analyzeService._facilityPiFilterObj.FacilityDashboardDataObj
        )
        .subscribe({
          next: (res: any) => {
            if (res) {
              this.showProgressSpinner = false;
              this.FilterDashboardFacultyPiList = res.data == null ? null : res.data.slice(0, 20);
              this.bodyFacilityImprovefacilityList = [];
              if (this.FilterDashboardFacultyPiList != null) {
                this.analyzeService._facilityPiRecord.FacilityDashboardRecord =
                  this.FilterDashboardFacultyPiList;

                this.FilterDashboardFacultyPiList.forEach((element: any) => {
                  switch (element.QualityMetrics) {
                    case "Door to TS Notification Avg Minutes": element.QualityMetrics = "Door to Notification Mean (Min:Sec)"; break;
                    case "Door to TS Notification Median Min": element.QualityMetrics = "Door to Notification Median (Min:Sec)"; break;
                    case "Activation to Assessment Avg Mins": element.QualityMetrics = "Activation to Assessment Mean (Min:Sec)"; break;
                    case "Activation to Assessment Median Mins": element.QualityMetrics = "Activation to Assessment Median (Min:Sec)"; break;
                    case "Assessment to Thrombolytic Decision-making Avg Mins": element.QualityMetrics = "Assessment to Thrombolytic Decision Mean (Min:Sec)"; break;
                    case "Assessment to Thrombolytic Decision-making Median Mins": element.QualityMetrics = "Assessment to Thrombolytic Decision Median (Min:Sec)"; break;
                    case "Thrombolytic Medical Decision to Admin Avg Minutes": element.QualityMetrics = "Thrombolytic Medical Decision to Thrombolytic Administration Mean (Min:Sec)"; break;
                    case "Thrombolytic Decision Making to Admin Median Mins": element.QualityMetrics = "Thrombolytic Medical Decision to Thrombolytic Administration Median (Min:Sec)"; break;
                    case "DTN Less or Equal 30 Minutes %": element.QualityMetrics = "DTN equal to or less than 30 minutes (%)"; break;
                    case "DTN Less or Equal 45 Minutes %": element.QualityMetrics = "DTN equal to or less than 45 minutes (%)"; break;
                    case "DTN Less or Equal 60 Minutes %": element.QualityMetrics = "DTN equal to or less than 60 minutes (%)"; break;
                    case "TS Notification to Initial Response Avg Minutes": element.QualityMetrics = "TS Notification to Initial Response Mean Min"; break;
                    case "Door to Needle Average (min:sec)": element.QualityMetrics = "Door to Needle Mean (Min:Sec)"; break;
                    case "Door to Needle Median (min:sec)": element.QualityMetrics = "Door to Needle Median (Min:Sec)"; break;
                  }
                  let facilityDashbaordValue: any = [];
                  facilityDashbaordValue.push(element.QualityMetrics)
                  element.objDailyData.forEach((value: any) => {
                    facilityDashbaordValue.push(value.Value)
                    if (this.reportType.toLowerCase() == 'monthly') {
                      facilityDashbaordValue.push(value.Goal)
                    }
                  });
                  this.facilityDasboardReplica.push(facilityDashbaordValue);

                });
                this.headerFacilityImprovefacilityList = this.NameListforData(this.fromMonth, this.toMonth);
                this.facilityDasboardReplica.forEach((element: any) => {
                  let filtersdata: any = []
                  element.forEach((value: any) => {
                    if (value != null) {
                      filtersdata.push(value);
                    }
                  });
                  this.bodyFacilityImprovefacilityList.push(filtersdata);
                })
                
                this.bodyFacilityImprovefacilityList.forEach((val: any,index:any) => {
                  if(index === 2){
                    for (let i = 1; i < val.length; i++) {
                      if ( val[i] === '-1%') {
                        val[i] = '0%';
                      }
                  }
                  }
                });
                this.totalRecords = res.data.length;
                this.analyzeService.currentDateTime();
                loader.value = false;
                excel_chartDisabe.value = false;
                onClickDisable.value = false;
                this.filter_option = filterOption;
              }
            }
          },
          error: (err: any) => { },
        })
    );
  }

  NameListforData(startDate: any, endDate: any) {
    let beginDate = new Date(startDate);
    let lastDate = new Date(endDate);
    let nameSeriesList: any = [];
    nameSeriesList.push('Graphs');
    nameSeriesList.push('QualityMetrics');
    if (this.reportType == 'monthly') {
      while (beginDate <= lastDate) {
        nameSeriesList.push(beginDate.toLocaleString('en-US', { month: 'short' }).substring(0, 3) + ' Data ' + beginDate.toLocaleString('en-US', { year: 'numeric' }));
        if (this.FilterType.toLowerCase() == 'facility') {
          nameSeriesList.push(beginDate.toLocaleString('en-US', { month: 'short' }).substring(0, 3) + ' Goals ' + beginDate.toLocaleString('en-US', { year: 'numeric' }));
        }
        beginDate.setMonth(beginDate.getMonth() + 1);
      }
    }
    else if (this.reportType == 'daily') {
      for (let i = beginDate; i <= lastDate; i.setDate(i.getDate() + 1)) {
        nameSeriesList.push('Day' + i.getDate());
      }
    }
    else if (this.reportType == 'weekly') {
      nameSeriesList.push('Week');
    }
    else if (this.reportType == 'cumulative') {
      nameSeriesList.push('Cumulative');
    }
    return nameSeriesList;
  }

  maxdoortostartmeancal: any;
  getChartValues(value: any, i: any) {
    this.loading[i] = true;
    this.chartDatasets = [];
    this.barChartDatasets = [];
    this.chartFoundBool = false;
    this.analyzeService._facilityPiFilterObj.FacilityDashboardDataObj.data.Status =
      value[0];
    this.subscription.push(
      this.analyzeService
        .GetFacilityDashboardChartValues(this.RoleName, this.UId,
          this.analyzeService._facilityPiFilterObj.FacilityDashboardDataObj
        )
        .subscribe({
          next: (res: any) => {
            if (res) {
              this.doortostartmeancal = [];
              this.doortostartmediancal = [];
              this.minDate = 0;
              this.flag = 0;
              this.chartBool = true;
              this.chartsTitle = res.data[0].Title;
              this.chartsMean = res.data[0].Mean;
              this.chartsMeanCalculation = res.data[0].MeanCalculation;
              this.chartsMinDate = res.data[0].MinDate;
              this.chartsCategory = res.data[0].Category;
              if (this.chartsMeanCalculation?.length > 0) {
                const value = this.chartsMeanCalculation?.some((val: any) => val != null)
                if (value) {
                  this.minDate = new Date(res.data[0].MinDate).getTime();
                }
              }

              if (
                this.chartsTitle == 'THROMBOLYTIC ADMINISTERED #' ||
                this.chartsTitle == '% 10 Min or Less Activation (EMS)' ||
                this.chartsTitle == '% 10 Min or Less Activation (PV)' ||
                this.chartsTitle == 'DTN equal to or less than 30 minutes (%)' ||
                this.chartsTitle == 'DTN equal to or less than 45 minutes (%)' ||
                this.chartsTitle == 'DTN equal to or less than 60 minutes (%)'
              ) {
                this.showAllFacilityDashBoardCharts(
                  this.chartsTitle,
                  this.chartsMean,
                  this.chartsMeanCalculation,
                  this.chartsMinDate,
                  this.chartsCategory,
                  this.flag
                );
              }
              else if (res.data[0].Title == null) {
                this.chartFoundBool = true
              }
              else {
                if (this.chartsMeanCalculation != null) {
                  this.chartsMeanCalculation.forEach((val: any) => {
                    if (val != null) {
                      this.doortostartmeancal.push(
                        new Date(this.chartsMinDate + ' ' + val).getTime()
                      );
                    }
                    else {
                      this.doortostartmeancal.push(val);
                    }
                  });
                } else {
                  this.doortostartmeancal.push(0);
                }

                this.maxdoortostartmeancal = Math.max(...this.doortostartmeancal);
                if (res.data[0].Title != null) {
                  this.showAllFacilityDashBoardCharts(
                    this.chartsTitle,
                    this.chartsMean,
                    this.doortostartmeancal,
                    this.chartsMinDate,
                    this.chartsCategory,
                    this.flag
                  );
                }

              }
            }
            this.loading[i] = false;
          },
          error: (err: any) => { },
        })
    );
  }

  showAllFacilityDashBoardCharts(
    Title: any,
    Mean: any,
    MeanCalculations: any,
    MinDate: any,
    Category: any,
    flag: any
  ) {
    if (
      Title == 'THROMBOLYTIC ADMINISTERED #' ||
      Title == '% 10 Min or Less Activation (EMS)' ||
      Title == '% 10 Min or Less Activation (PV)' ||
      Title == 'DTN equal to or less than 30 minutes (%)' ||
      Title == 'DTN equal to or less than 45 minutes (%)' ||
      Title == 'DTN equal to or less than 60 minutes (%)'
    ) {
      this.multiAxisBarChartData = {
        labels: Category,
        datasets: [
          {
            label: Mean,
            data: MeanCalculations,
            fill: true,
            backgroundColor: '#E31C79'
          },
        ],
      };
      this.barBool = true;
      this.seriesColors = ['#ed2078'];
      this.name = Mean;
      this.chartsTitle = Title;
      this.barChartDatasets = MeanCalculations;
      this.barChartCategories = Category;
    } else {
      this.barBool = false;
      this.name = Mean;
      this.chartsTitle = Title;
      this.chartDatasets = this.yAxisValueForLineChart(MeanCalculations);
      this.lineChartCategories = Category;
      let a = -1;
      this.labelContent = (e: SeriesLabelsContentArgs): any => {
        if (a == this.array1.length - 1) {
          a = -1
        }
        a++
        return this.array1[a];
      };
    }
  }

  formatYAxisLabel(val: AxisLabelContentArgs): any {
    return ((new Date(val.value)).getHours() * 60 + (new Date(val.value)).getMinutes() + ':' + (new Date(val.value)).getSeconds());
  }

  isAscending: boolean = true;
  field: any = '';
  tempField: any;
  customSort(event: any) {
    if (this.tempField != event.multiSortMeta[0].field) {
      this.isAscending = true;
    }
    this.tempField = event.multiSortMeta[0].field;

    for (let i = 1; i < this.headerFacilityImprovefacilityList.length; i++) {
      if (event.multiSortMeta[0].field == this.headerFacilityImprovefacilityList[i]
      ) { this.field = i - 1; break; }
    }
    event.data.sort((data1: any, data2: any) => {
      let value1 = data1[this.field];
      let value2 = data2[this.field];
      let result = 0;

      if (typeof value1 === 'string' && typeof value2 === 'string') {
        result = value1.localeCompare(value2, undefined, { numeric: true });
      } else if (typeof value1 === 'number' && typeof value2 === 'number') {
        result = value1 - value2;
      } else if (typeof value1 === 'string' && typeof value2 === 'number') {
        result = 1;
      } else if (typeof value1 === 'number' && typeof value2 === 'string') {
        result = -1;
      }

      if (!this.isAscending) { result = -result; }
      return result;
    });
    this.isAscending = !this.isAscending;
  }

  hideChartDiaglog() {
    this.chartBool = false;
  }

  exportPdf(): void {
    this.exportPdfLoader = true;
    drawDOM(document.getElementById("htmlData") as HTMLElement, {
      paperSize: "auto",
      scale: 0.8,
      landscape: true,
      margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" }

    }).then((group: Group) => {
      return exportPDF(group);
    })
      .then((dataUri) => {
        saveAs(dataUri, "Export.pdf");
        this.exportPdfLoader = false;
      });
  }

  yAxisValueForLineChart(value: any) {
    this.array = [];
    this.array1 = [];
    value.forEach((val: any) => {
      if (val != null) {
        let calculatedDate = new Date(val).getHours() * 60 + new Date(val).getMinutes() + ':' + new Date(val).getSeconds().toString().padStart(2, '0');
        this.array.push(calculatedDate);
        this.array1.push(calculatedDate);
      } else {
        this.array.push(val);
      }
    });

    const numberArray = this.array.map((str: any) => str == null ? null : parseInt(str, 10));
    return numberArray;
  }

  calculateRotation() {
    let numLabels = this.array.length;

    let rotation = 0;
    if (numLabels > 12) {
      rotation = -45;
    }
    return rotation;
  }

  ngOnDestroy() {
    if (this.subscription.length != 0) {
      this.subscription.forEach((i: any) => {
        i.unsubscribe();
      })
    }
    Object.getOwnPropertyNames(this)
      .filter(propName => Array.isArray((<any>this)[propName]))
      .forEach(propName => (<any>this)[propName] = []);

  }

  GetBackgroundColor(item1: any, item2: any, index: any): string {
    let style = ""
    if (item2?.length > 10 && (item2?.includes('Notification Mean') || (item2?.includes('Notification Median'))
      || (item2?.includes('Notification Mean')) || (item2?.includes('Notification Median'))
      || (item2?.includes('Assessment')) || (item2?.includes('Decision')))) {
      style = "color: white; background: #9f1f60;";
    }
    else if (item1[0].includes('%') && item1[index]?.length < 12 && parseInt(item1[index].split(':')[0]) < Number(item1[index + 1]) && !item1[0]?.includes('#')) {
      style = 'color: red; font-weight: bold;';
    }
    else if (!item1[0].includes('%') && item1[index]?.length < 12 && Number(item1[index].split(':')[0] + '.' + item1[index].split(':')[1]) > Number(item1[index + 1]) && !item1[0]?.includes('#')) {
      style = 'color: red; font-weight: bold;';
    }
    else {
      style = '';
    }
    return style;
  }
}
